<template>
  <el-row
    v-loading.fullscreen.lock="fullScreenLoading"
  >
    <el-col
      :sm="{span:14, offset: 5}"
      :md="{span:12, offset: 6}"
      :lg="{span:12, offset: 6}"
    >
      <el-header
        height="140px"
        class="app-header pt-50 pb-30"
      >
        <Menu />
        <h3 class="app-header-title mt-0">
          {{ $t('teams.edit-team') }}
        </h3>
      </el-header>
      <el-main>
        <el-form
          :model="team"
          :rules="getFormRules"
          ref="editTeamForm"
          label-position="top"
        >
          <el-form-item
            :label="$t('organization.name')"
            prop="name"
          >
            <el-input v-model="team.name" />
          </el-form-item>
          <el-form-item
            :label="$t('team.showTeamName')"
            prop="showsTeamName"
          >
            <el-switch v-model="team.showsTeamName" /> 
          </el-form-item>
          <el-form-item
            :label="$t('team.hideOnSelectTeamPage')"
            prop="hideOnSelectTeamPage"
          >
            <el-switch v-model="team.hideOnSelectTeamPage" />
          </el-form-item>
          <el-form-item
            :label="$t('organization.type-sharing-tips.title')"
            prop="sharingType"
          >
            <el-select
              v-model="team.sharingType"
            >
              <el-option
                :label="$t('organization.type-sharing-tips.options.individual')"
                value="Individual"
              />
              <el-option
                :label="$t('organization.type-sharing-tips.options.pooling')"
                value="Pooling"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="team.sharingType === 'Pooling'"
            :label="$t('teams.resp-contact')"
            prop="representativeUid"
          >
            <el-select
              v-model="team.representativeUid"
            >
              <el-option
                v-for="(employee, index) in employees"
                :key="index"
                :label="`${employee.name} ${employee.surName}`"
                :value="employee.empUid"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('teams.group-qr-code')"
            prop="qrCode"
          >
            <el-input-number
              :controls="false"
              v-model="team.qrCode"
            />
          </el-form-item>
          <el-form-item
            :label="$t('organization.defined-amount')"
            prop="defTipsAmount"
          >
            <defined-tips-repeater
              prop="defTipsAmount"
              :fields="team.defTipsAmount"
              @change-radio="changeRadio"
            />
          </el-form-item>
          <el-form-item
            :label="$t('organization.defined-percent')"
            prop="defTipsPercentage"
          >
            <defined-tips-repeater
              prop="defTipsPercentage"
              :fields="team.defTipsPercentage"
              @change-radio="changeRadio"
            />
          </el-form-item>
          <el-form-item class="mt-20">
            <el-row>
              <el-col :span="11">
                <router-link
                  :to="{name: 'Organization', params: { id: $route.params.id } }"
                  custom
                  v-slot="{ navigate }"
                >
                  <el-button
                    class="cancel-button"
                    @click="navigate"
                  >
                    {{ $t('form.cancel') }}
                  </el-button>
                </router-link>
              </el-col>
              <el-col
                :offset="2"
                :span="11"
              >
                <el-button
                  class="primary-button"
                  type="primary"
                  @click="submitForm('editTeamForm')"
                >
                  {{ $t('form.save') }}
                </el-button>
              </el-col>
            </el-row>
            <el-row class="mt-20">
              <el-button
                class="primary-outline-button"
                @click="deleteTeamDialogVisible = true"
              >
                {{ $t('teams.delete-team') }}
              </el-button>
            </el-row>
          </el-form-item>
        </el-form>
      </el-main>
    </el-col>
    <el-dialog
      title="Delete?"
      :visible.sync="deleteTeamDialogVisible"
      width="320px"
      :show-close="false"
      class="confirm-dialog"
    >
      <span>{{ $t('organization.wanna-delete') }}</span>
      <span
        slot="footer"
      >
        <el-row>
          <el-button
            type="primary"
            @click="deleteTeam()"
            class="primary-button"
          >
            {{ $t('yes') }}
          </el-button>
        </el-row>
        <el-row class="mt-20">
          <el-button
            type="text"
            @click="deleteTeamDialogVisible = false"
            class="primary-link"
          >
            {{ $t('no') }}
          </el-button>
        </el-row>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import Menu from '../Menu/Menu';
import DefinedTipsRepeater from '../Components/Repeaters/DefinedTipsRepeater';
import { usersAPI } from '../../shared/services/users.service'

export default {
  name: 'EditTeam',
  components: {
    Menu,
    DefinedTipsRepeater
  },
  data: () => ({
    deleteTeamDialogVisible: false,
    fullScreenLoading: false,
    team: {
      showsTeamName: false,
      hideOnSelectTeamPage: false,
      name: '',
      sharingType: '',
      representativeUid: '',
      qrCode: null,
      defTipsAmount: [
        {
          value: '',
          checked: false
        }
      ],
      defTipsPercentage: [
        {
          value: '',
          checked: false
        }
      ]
    },
    currentRepresentativeUid: '',
    employees: []
  }),
  computed: {
    getFormRules: function () {
      const defaultValueValidator = (rule, value, callback) => {
        let defaultValid = false;
        let validValues = true;
        value.map((el) => {
          if (el.checked) {
            defaultValid = true;
          }
          if (!el.value) {
            validValues = false;
          }
        });
        if (!validValues) {
          callback(new Error(this.$t('form.validation.all-items-populated')));
        }
        if (!defaultValid) {
          callback(new Error(this.$t('form.validation.one-item-default')));
        }
        callback();
      };
      return {
        name: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('organization.name') }),
            trigger: 'blur'
          }
        ],
        representativeUid: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('organization.resp-contact') }),
            trigger: 'blur'
          }
        ],
        sharingType: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('organization.type-sharing-tips.title') }),
            trigger: 'blur'
          }
        ],
        defTipsAmount: [
          { validator: defaultValueValidator }
        ],
        defTipsPercentage: [
          { validator: defaultValueValidator }
        ]
      };
    }
  },
  created () {
    this.$adminApi.get('/api/v1/entities/teams/' + this.$route.params.teamId).then((response) => {
      this.team = response.data;
      this.team.id = this.$route.params.teamId;
      this.team.beUid = this.$route.params.id;
      if (this.team.sharingType === 'Pooling') {
        this.currentRepresentativeUid = this.team.representativeUid;
      }
      this.$axios.get(`/api/v1/teams/${this.team.id}/employees?compress=true`).then((response) => {
        response.data.map((employee) => {
          if (employee.empStatus === 'Assigned') {
            this.employees.push(employee);
          }
        });
      });
    });
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveTeam();
        } else {
          return false;
        }
      });
    },
    saveTeam () {
      this.fullScreenLoading = true;
      this.$adminApi.put('/api/v1/entities/teams', this.team).then(async (response) => {
        this.fullScreenLoading = false;
        if (response.data.status === 'Success') {
       
          if (this.team.sharingType === 'Pooling' && this.currentRepresentativeUid.length && this.currentRepresentativeUid !== this.team.representativeUid) {
            const [ cognitoError ] = await usersAPI.addUserToGroup('team', this.team.representativeUid)

            if(cognitoError) {
              this.$message.error(this.$t('form.something-wrong'));
              return
            } 

            this.$adminApi.get(`/api/v1/entities/teams/representatives/${this.currentRepresentativeUid}`).then(async (teams) => {
                  if (!teams.data.length) {
                    const [ cognitoError ] = await usersAPI.removeUserFromGroup('team', this.currentRepresentativeUid)

                    if(cognitoError) {
                      this.$message.error(this.$t('form.something-wrong'));
                      return
                    } 
                   this.$message.success(this.$t('form.item-changed', { item: this.$t('re-conciliation.choose-team.team') }));
                   this.$router.push({ name: 'Organization', params: { id: this.$route.params.id } });
                  }
                });
          } else {
            this.$message.success(this.$t('form.item-changed', { item: this.$t('re-conciliation.choose-team.team') }));
            this.$router.push({ name: 'Organization', params: { id: this.$route.params.id } });
          }
        } else {
          this.$message.warning(response.data.status);
        }
      }).catch(() => {
        this.fullScreenLoading = false;
        this.$message.error(this.$t('form.something-wrong'));
      });
    },
    deleteTeam () {
      this.fullScreenLoading = true;
      this.$adminApi.delete('/api/v1/entities/teams/' + this.$route.params.teamId).then((response) => {
        this.fullScreenLoading = false;
        if (response.data.status === 'Deleted') {
          this.$message.success(this.$t('form.item-deleted', { item: this.$t('re-conciliation.choose-team.team') }));
          this.$router.push({ name: 'Organization', params: { id: this.$route.params.id } });
        } else {
          this.$message.warning(response.data.status);
        }
      });
    },
    changeRadio (field) {
      this.$refs['editTeamForm'].validateField(field);
    }
  }
};
</script>

<style scoped lang="scss">

</style>
